import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import VitrineImoveis from '../../components/VitrineImoveis/VitrineImoveis';

export default function BuscaImoveis() {
  return (
    <>
      <Header />
      <VitrineImoveis />
      <Footer />
    </>
  );
}
